<template>
  <!-- Recent Articles -->
  <section class="property-articles common-padding">
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-9 aos aos-init aos-animate" data-aos="fade-up">
            <h2>Recent Articles</h2>
            <p>The most trendy accommodations available</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          >
            <router-link to="categories" class="btn btn-view"
              >View all Properties</router-link
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 aos" data-aos="fade-up">
          <div class="car-class-carousel">
            <div class="owl-carousel blog-slider">
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexNineArticle" :key="item.id">
                  <div class="blog grid-blog blog-two aos" data-aos="fade-up">
                    <div class="blog-image">
                      <router-link to="blog-details"
                        ><img
                          class="img-fluid"
                          :src="require(`@/assets/img/blog/${item.image}`)"
                          alt="Post Image"
                      /></router-link>
                    </div>
                    <div class="blog-content">
                      <h3 class="blog-title">
                        <router-link to="blog-details">{{
                          item.title
                        }}</router-link>
                      </h3>
                      <ul class="entry-meta meta-item">
                        <li class="date-icon">
                          <i class="feather-calendar"></i> {{ item.date }}
                        </li>
                      </ul>
                      <p class="blog-description">
                        {{ item.content }}
                      </p>
                      <div class="viewlink">
                        <router-link to="blog-details">Read More</router-link>
                      </div>
                    </div>
                  </div>
                </Slide>
                <template #addons>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Recent Articles -->

  <!-- Become Agent -->
  <section class="join-us-dealer join-us-dealer-sec">
    <div class="join-us-dealer-bg home-nine-bg">
      <img src="@/assets/img/bg/agent-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="row align-items-center aos" data-aos="fade-up">
        <div class="col-lg-6 col-md-12">
          <div class="joinus-dealer-content">
            <h3 class="aos" data-aos="fade-up" data-aos-delay="200">
              Become a Real Estate Agent
            </h3>
            <p class="aos" data-aos="fade-up" data-aos-delay="300">
              Premium and essential services in Listee, contributing to
              enhancing residents' life experience
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="join-as-dealer-btn">
            <router-link to="signup">View all Prroperties</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Become Agent -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineArticle from "@/assets/json/indexNineArticle.json";
export default {
  data() {
    return {
      IndexNineArticle: IndexNineArticle,
      Venue: ["Wedding Venue", "Reception", "Party Hall"],
      Location: ["Bangalore, India", "Delhi", "Hyderabad"],
      Guest: ["10", "20", "30"],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1000: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
